import type { ImperativePanelHandle } from "react-resizable-panels";

import { type RefObject, useLayoutEffect } from "react";

interface UsePanelCollapseProps {
    panelRef: RefObject<ImperativePanelHandle | null>;
    isCollapsed: boolean | undefined;
}

export const usePanelCollapse = ({ panelRef, isCollapsed }: UsePanelCollapseProps) => {
    useLayoutEffect(() => {
        try {
            panelRef.current?.[isCollapsed ? "collapse" : "expand"]();
        } catch (error) {
            console.error(`Error toggling panel:`, error);
        }
    }, [isCollapsed, panelRef]);
};
